import { Experience, Role } from "types/types"

export default class PreferredNurseOption {
    nurse_id!: number
    full_name!: string
    nurse_role!: Role
    gdc_number!: string
    approved!: boolean
    hygienist_approved!: boolean
    sedation_approved!: boolean
    radiography_approved!: boolean 
    implant_experience!: Experience
    orthodontics_experience!: Experience
}